import { Component, OnInit } from '@angular/core';
import { ModalService } from 'src/app/services/modal/modal.service';
import { PopUpInformationComponent } from '../../shared/pop-up-information/pop-up-information.component';
import { Router } from '@angular/router';
import { StoresService } from 'src/app/services/stores/stores.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  year = new Date().getFullYear()


  id_store_current : string = 'rednumbers';

  constructor(
    private modalService: ModalService<PopUpInformationComponent>,
    private router: Router,
    private stores: StoresService,

  ) {
    this.getId()
  }

  ngOnInit(): void {
  }


  getId(){
    this.stores.getStoreId()
    .subscribe(id => {
      if(id !== null && id !== "null" ){
        this.id_store_current = id
      }
    } )
  }

  redirect(route:string){
    this.router.navigate([`/${this.id_store_current}/${route}`])
  }

  async open(type:string): Promise<void> {
    this.modalService.setType(type)
    const {PopUpInformationComponent} = await import(
      '../../shared/pop-up-information/pop-up-information.component'
    );

    await this.modalService.open(PopUpInformationComponent);
    this.modalService.nameComponent.next('PopUpInformationComponent')
  }

}
